import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SERVER_API_URL } from 'app/app.constants';
import {
    IDeploymentRunner,
    IRunnerCommandBatch,
    IRunnerCommandRequest,
    IRunnerEvent
} from 'app/shared/model/FDEExtractorRunnerService/runner-command.model';

@Injectable({ providedIn: 'root' })
export class DeploymentsService {
    private readonly commandResource = SERVER_API_URL + 'fdeextractorrunnerservice/api/extractor-runners/command';
    private readonly branchesResource = SERVER_API_URL + 'fdeextractorrunnerservice/api/deployments/branches';
    private readonly eventsResource = SERVER_API_URL + 'fdeextractorrunnerservice/api/deployments/events';
    private readonly runnersResource = SERVER_API_URL + 'fdeextractorrunnerservice/api/deployments/runners';

    constructor(private readonly http: HttpClient) {}

    listBranches(): Observable<HttpResponse<string[]>> {
        return this.http.get<string[]>(this.branchesResource, { observe: 'response' });
    }

    refreshBranches(): Observable<HttpResponse<string[]>> {
        return this.http.post<string[]>(this.branchesResource + '/refresh', null, { observe: 'response' });
    }

    dispatch(request: IRunnerCommandRequest): Observable<HttpResponse<IRunnerCommandBatch>> {
        return this.http.post<IRunnerCommandBatch>(this.commandResource, request, { observe: 'response' });
    }

    listRecentEvents(limit: number = 200): Observable<HttpResponse<IRunnerEvent[]>> {
        return this.http.get<IRunnerEvent[]>(`${this.eventsResource}?limit=${limit}`, { observe: 'response' });
    }

    listRunners(): Observable<HttpResponse<IDeploymentRunner[]>> {
        return this.http.get<IDeploymentRunner[]>(this.runnersResource, { observe: 'response' });
    }
}
